import React, {Component} from "react";
import Paper from '@mui/material/Paper';
import {
    Checkbox,
    FormControlLabel,
    List,
    ListItem,
    FormLabel
  } from "@mui/material";
import './css/InverterSelectorForm.css'
import {Card, CardHeader, CardContent} from "@mui/material"


export class WarrantySelectView extends Component{

    constructor(props){
      super(props);
      props.warrantyList["Standard Onsite Startup, Training and Warranty"] = false;
      this.state = {
        warrantyData: this.props.warrantyList,
      };
    }

    saveWarrantyList = (event) =>{

        this.setState(prevState => ({
            warrantyData: {
              ...prevState.warrantyData,
              [event.target.value]: !prevState.warrantyData[event.target.value],
            },
          }) , ()=>{
            //console.log("Finished updating warrantyData")
            //console.log(this.state.warrantyData)

            this.props.setWarrantyList(this.state.warrantyData)
          });

    }

   
    render(){        
        return (
          //App starts here

          <Card elevation={10}>
            <CardHeader
          titleTypographyProps={{
            fontFamily: 'ford-normal',
          }} className="paperh-title" title="Warranty & Training" />
            <CardContent>
              <Paper elevation={5}>
                <FormLabel style={{fontFamily: "Ford-Normal"}}> Select Warranty and Training Options</FormLabel>
                <List>
                  {Object.keys(this.state.warrantyData).map((item, index) => (
                    <ListItem key={index}>
                      <Card variant="">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!this.state.warrantyData[item]}
                              value={item}
                              onChange={this.saveWarrantyList}
                            />
                          }
                          label={item}
                          sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
                        />
                      </Card>
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </CardContent>
          </Card>
        );
    }
}

export default WarrantySelectView; 